<template>
    <form>
        <label>
            <span>Background of title slide</span>
            <input type="color" v-model="style.backgroundTitle"/></label>
        <label>
            <span>Background of normal slides</span>
            <input type="color" v-model="style.background"/>
        </label>
        <label>
            <span>Font</span>
            <select v-model="style.fontFamily">
                <option value="arial">Arial</option>
                <option value="calibri">Calibri</option>
                <option value="Times new roman">Times New Roman</option>
                <option value="Consolas">Consolas</option>
            </select>
        </label>
        <label>
            <span>Format</span>
            <select v-model="format">
                <option value="pptx">PPTX</option>
<!--                <option value="ppt">ppt</option>-->
<!--                <option value="odp">ODP</option>-->
<!--                <option value="pdf">pdf</option>-->
            </select>
        </label>
        <button @click.prevent="download()" :class="{isLoading:downloadingStatus.status.name=='pending'}">Download</button>
    </form>
    <slides-preview v-if="preview" :xml="preview" :style="styleFull" @changeXml="onSlidesChange"
                    :slidesChangeSymbol="slidesChangeSymbol"/>

</template>
<script>
import SlidesPreview from "@/components/SlidesPreview.vue";
import ReactivePromiseStatus from "reactive-promise-status";
import Color from "colorjs.io";
import {Api} from "@/api";
import InlineRestClient from "inline-rest-client";

export default {
    components: {
        SlidesPreview
    },
    props: {
        doc: {}
    },
    data() {
        return {
            style: {
                backgroundTitle: '#ffffff',
                background: '#ffffff',
                fontFamily: 'arial'
            },
            preview: null,
            downloadingStatus: new ReactivePromiseStatus(),
            slidesChangeSymbol: Symbol(),
            format: 'pptx',

        }
    },
    methods: {
        onSlidesChange(xml) {
            this.preview = xml;
            this.slidesChangeSymbol = Symbol();
        },
        download() {
            this.downloadingStatus.promise = this._download();
        },
        async _download() {
            console.log('download')
            const ApiDownload = new InlineRestClient(Api.__config);
            ApiDownload.responseType = 'blob'
            const blob = await ApiDownload.download({
                xml: new XMLSerializer().serializeToString(this.preview),
                format: this.format,
                style: this.styleFull
            })
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'presentation.' + this.format;
            a.click();
        },
    },
    computed: {
        styleFull() {
            const background = new Color(this.style.background);
            const color = background.luminance > 0.4 ? '#000000' : '#ffffff';
            const backgroundTitle = new Color(this.style.backgroundTitle);
            const colorTitle = backgroundTitle.luminance > 0.4 ? '#000000' : '#ffffff';
            return {
                ...this.style,
                color, colorTitle
            }
        }
    },
    watch: {
        doc: {
            handler() {
                this.preview = this.doc;
            },
            deep: true,
            immediate: true
        }
    },
}
</script>
<style lang="scss" scoped>
form {
    max-width: 1880px;
    margin: auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr max-content;

    label {
        margin: 0;
    }

    input[type="color"] {
        width: 50px;
    }

    span {
        width: auto;
    }

    select {
        min-width: 50px;
    }
}
</style>
